export type Bonus = {
  number: number;
  title: string;
  subtitle: string;
  description: string;
  included: string[];
  benefit: string;
  note?: string;
  /** Horizontal crop position (percent) of this bonus inside the product mockup */
  cropX: number;
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'HVAC Electrical Troubleshooting Quick-Reference Cards™',
    subtitle: 'Your Five-Stage Workflow at a Glance',
    description: 'A compact set of reference cards summarizing the HVAC ELECTRICAL FAULT PATHWAY™.',
    included: [
      'Five-Stage Troubleshooting Reference Card',
      'Electrical Assessment Priority Card',
      'Circuit Investigation Reminder Card',
      'Verification Planning Reference Card',
      'Documentation Completion Checklist',
    ],
    benefit: 'Quickly reference the workflow without searching through the complete volumes.',
    cropX: 3,
  },
  {
    number: 2,
    title: 'HVAC Electrical Fault Scenario Decision Pack™',
    subtitle: 'Organize Common Service Scenarios Using Practical Decision Maps',
    description:
      'A collection of structured investigation worksheets for frequently encountered HVAC electrical complaints.',
    included: [
      'No-Start Electrical Investigation Map',
      'Intermittent Operation Assessment Tree',
      'Control Circuit Response Investigation Map',
      'Contactor & Relay Fault Assessment Worksheet',
      'Electrical Protection Event Documentation Form',
    ],
    benefit:
      'Start common electrical investigations with an organized scenario-specific worksheet instead of a blank page.',
    cropX: 27.9,
  },
  {
    number: 3,
    title: 'HVAC Electrical Safety & Test Readiness Checklist™',
    subtitle: 'A Pre-Task Planning Resource for Qualified Professionals',
    description: 'A practical checklist designed to support safety planning before electrical troubleshooting activities.',
    included: [
      'Electrical Hazard Assessment Checklist',
      'Equipment Isolation Planning Form',
      'Lockout/Tagout Procedure Reference Checklist',
      'Test Instrument Suitability Review',
      'Manufacturer Procedure Verification Form',
      'Stop-Work & Escalation Decision Checklist',
    ],
    benefit:
      'Document the safety prerequisites and professional authorization requirements that must be addressed before testing.',
    note: 'This resource supplements, but never replaces, employer-approved safety procedures, applicable regulations, or required technical training.',
    cropX: 51.8,
  },
  {
    number: 4,
    title: 'HVAC Electrical Measurement Logbook™',
    subtitle: 'Keep Your Electrical Findings Organized in One Place',
    description: 'A reusable documentation system for recording measurements and related diagnostic observations.',
    included: [
      'Electrical Measurement Log Template',
      'Expected vs. Observed Value Worksheet',
      'Test Conditions Documentation Form',
      'Equipment Reference Record',
      'Measurement Follow-Up Tracker',
    ],
    benefit: 'Keep authorized measurement results organized and connected to the relevant equipment specifications.',
    cropX: 75.7,
  },
  {
    number: 5,
    title: 'HVAC Electrical Service Handoff Toolkit™',
    subtitle: 'Make Your Troubleshooting Findings Easier to Communicate',
    description:
      'A professional reporting toolkit designed for technicians who need to document findings for supervisors, service teams, or customers.',
    included: [
      'Technician-to-Technician Handoff Template',
      'Electrical Findings Summary Sheet',
      'Recommended Next Steps Form',
      'Unresolved Fault Documentation Checklist',
      'Service Completion Communication Template',
    ],
    benefit: 'Communicate what was investigated, what was confirmed, and what still requires attention.',
    cropX: 99.6,
  },
];
